/* eslint-disable react/jsx-no-useless-fragment */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Autocomplete, Loader, Skeleton } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { IconSearch, IconX } from '@tabler/icons';
import { EventKind } from '../../Types/EventT';
import { EventS } from '../../Service/EventS';
import { EventContext } from '../../Service/Context/EventContext';
import Dot from '../../Atoms/Dot';
import { isDefined } from '../../Service/ValidationS';

const EventKindSelect = () => {
  const { event, loadingEvent, handleChange } = useContext<any>(EventContext);
  const [loading, setLoading] = useState(false);
  const [kinds, setKinds] = useState<EventKind[]>([]);
  const existingKinds = kinds.map((k) => k.name);
  const { id: eventId, kind, kindColor } = event ?? {};
  const [kindValue, setKindValue] = useState(kind ?? '');

  useEffect(() => {
    setLoading(true);
    EventS.fetchEventKinds()
      .then(setKinds)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (event && !isDefined(kindValue) && isDefined(event.kind)) {
      setKindValue(event.kind);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  const getKindId = async () => {
    if (kindValue === '') {
      return null;
    }
    const selectedKind = kinds.find((_kind) => _kind.name === kindValue);
    if (selectedKind) {
      // Existing kind selected
      return selectedKind.id;
    }
    // Creating new event kind
    const newKind = await EventS.createEventKind({ name: kindValue });
    if (newKind) {
      setKinds([...kinds, newKind]);
      return newKind.id;
    }
    return undefined;
  };

  const onBlur = async () => {
    if (kindValue !== kind) {
      setLoading(true);
      const kindId = await getKindId();
      if (kindId !== undefined) {
        const patch = await EventS.editEvent(eventId, { eventKindId: kindId });
        if (patch) {
          handleChange(patch);
          setKindValue(patch.kind ?? '');
        }
      }
      setLoading(false);
    }
  };

  const clear = async () => {
    const patch = await EventS.editEvent(eventId, { eventKindId: null });
    if (patch) {
      handleChange(patch);
      setKindValue('');
    }
  };

  const getIcon = () => {
    if (!kind) {
      return <IconSearch size={16} />;
    }
    if (kindColor) {
      return <Dot withoutShadow colour={kindColor} />;
    }
    return null;
  };

  if (loadingEvent) {
    return <Skeleton height={40} />;
  }

  return (
    <Autocomplete
      placeholder="Art durchsuchen"
      rightSection={
        loading ? (
          <Loader size="xs" />
        ) : (
          <>{kind && <IconX size={16} onClick={clear} style={{ cursor: 'pointer' }} />}</>
        )
      }
      value={kindValue}
      icon={getIcon()}
      limit={16}
      onBlur={onBlur}
      onChange={(val) => setKindValue(val)}
      data={existingKinds}
      label="Art des Events"
    />
  );
};

export default EventKindSelect;
